export const header = {
    height: '40px',
    position: 'relative',
}

export const footer = {height: '30px'}

export const content = {
    margin: '0 5px',
    maxHeight: 'calc(100vh - 40px - $$headerHeight)',
    overflowY: 'auto',
    padding: '0 25px',
}

export const contentInner = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    img: {maxWidth: '100%'},
    justifyContent: 'center',
}

export const closeButton = {
    position: 'absolute',
    right: '5px',
    top: '5px',
}

export const heading = {
    color: '$embedModalHeader',
    fontFamily: '$embedModalHeader',
    fontSize: '$embedModalHeader',
    fontStyle: '$embedModalHeader',
    fontVariant: '$embedModalHeader',
    fontWeight: '$embedModalHeader',
    lineHeight: '$embedModalHeader',
    margin: 0,
    textAlign: 'center',
}
export const text = {textAlign: 'center'}

export const iconWrapper = {
    color: '$embedModalIcon',
    height: '60xp',
    svg: {
        height: '100%',
        width: '100%',
    },
    width: '60px',
}

export const buttonsWrapper = {
    button: {
        marginBottom: '10px',
        padding: '$button',
        width: '100%',
    },
    width: '100%',
}

